const HTML = ({ html }) => {
  // Takes HTML as a string and renders a <div></div>
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

export default HTML
